module.exports = __webpack_public_path__ + "static/media/microsoft-office365-icon.4d3a5a6b.svg";